import { render, staticRenderFns } from "./BotaoAvancar.vue?vue&type=template&id=0605a023&scoped=true"
import script from "./BotaoAvancar.vue?vue&type=script&lang=js"
export * from "./BotaoAvancar.vue?vue&type=script&lang=js"
import style0 from "./BotaoAvancar.vue?vue&type=style&index=0&id=0605a023&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0605a023",
  null
  
)

export default component.exports